export default __webpack_public_path__ + "static/dosBicicletasDiferentes-fb8315b6dbb9b8fe41cde5ae3cdbbbf6.png";